export const SET_PROGRAMS = 'SET_PROGRAMS';

export const ADD_PROGRAM = 'ADD_PROGRAM';

export const CLEAR_PROGRAMS = 'CLEAR_PROGRAMS';